<div class="forgot-password-container">
    <div class="forgot-password-card">
      <h3>Forgot Password</h3>
      <p>Enter your email address below and we’ll send you a link to reset your password.</p>
  
      <!-- Form to input email -->
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
        <div class="forgot-password-field">
          <input 
            type="email" 
            formControlName="email" 
            placeholder="Enter your email address"
            [class.error]="f.email.invalid && f.email.touched"
          />
          <mat-error *ngIf="f.email.invalid && f.email.touched">
            Please enter a valid email.
          </mat-error>
        </div>
  
        <!-- Button with loading state -->
        <button type="submit" class="forgot-password-btn" [disabled]="isSubmitting || forgotPasswordForm.invalid">
          <ng-container *ngIf="!isSubmitting">Send Reset Link</ng-container>
          <ng-container *ngIf="isSubmitting">Sending...</ng-container>
        </button>
  
        <a routerLink="/sign-in" class="back-to-login">Back to sign in</a>
      </form>
  
      <!-- Success Message -->
      <div *ngIf="successMessage" class="success-message">
        {{ successMessage }}
      </div>
  
      <!-- Error Message -->
      <div *ngIf="isError" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  